<div class="saldo-card">
  <div>
    <div class="top-text" *ngIf="showTopText">
      <div class="skeleton"></div>
    </div>
    <div class="main-text" *ngIf="showMainText">
      <div class="skeleton"></div>
    </div>
    <div class="bottom-text" *ngIf="showBottomText">
      <div class="skeleton"></div>
    </div>
  </div>
  <div *ngIf="showMainText2">
    <div class="top-text" *ngIf="showTopText2">
      <div class="skeleton"></div>
    </div>
    <div class="main-text">
      <div class="skeleton"></div>
    </div>
    <div class="bottom-text" *ngIf="showBottomText2">
      <div class="skeleton"></div>
    </div>
  </div>
  <div *ngIf="showMainText2">
    <div class="top-text" *ngIf="showTopText3">
      <div class="skeleton"></div>
    </div>
    <div class="main-text">
      <div class="skeleton"></div>
    </div>
    <div class="bottom-text" *ngIf="showBottomText3">
      <div class="skeleton"></div>
    </div>
  </div>
</div>
